module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/1-bg-5bdd947e91cf02742d662f8ccbd45de1.png";